import MainTemplate from 'components/templates/MainTemplate'
import DOMAIN from 'constants/domains'
import React from 'react'
import { getDomain ,isKsDomain, isSaficDomain } from 'utils/domain'
import Text from 'components/elements/texts/Text'
import styled from 'styled-components'
import { useServiceEndProcess, StatesProps } from '../../utils/commonHooks'
import { QnStatesProps } from '../../states/QnState'

/*
 * QN-09: キャンセル画面
 */
const Canceled: React.FC<StatesProps> = (props: QnStatesProps) => {
  useServiceEndProcess(props)

  /** クライアントごとで表示文言の文字色を定義する */
  const messageColor = isKsDomain() ? 'var(--color-text)' : isSaficDomain() ? 'var(--color-text-for-main-background)' :{
    [DOMAIN.SJ]: 'var(--color-text)', // 黒色(#111111)
  }[getDomain()]

  return (
    <MainTemplate
      title={'キャンセルのご連絡を\n承りました。'}
      content={
        <>
          <IconMargin />
          <CenterMessage>
            <Text color={messageColor}>
              {
                'キャンセルにお心あたりのない場合は、\nお手数ですが、下記ボタンよりご連絡\nください。'
              }
            </Text>
          </CenterMessage>
        </>
      }
      showContact
      background={'rgba(240, 240, 240, 1.0)'}
    />
  )
}

/** アイコンを設定しないためアイコンの高さ分のマージンを空ける */
const IconMargin = styled.div`
  margin-top: 150px;
`

/** メッセージ部分の表示を左右中央寄せに表示する */
const CenterMessage = styled.div`
  display: flex;
  justify-content: center;
`

export default Canceled
